// Settes i bygget fra GOOGLE_PLACES_API_KEY (se Dockerfile / DigitalOcean).
const GOOGLE_API_KEY = process.env.REACT_APP_GOOGLE_PLACES_API_KEY ?? "";

declare global {
  interface Window {
    google: any;
  }
}

let scriptLoaded = false;
let loadPromise: Promise<void> | null = null;

/** Laster Google Maps JS API (places) én gang. */
export const loadGoogleMapsScript = (): Promise<void> => {
  if (scriptLoaded || window.google?.maps) {
    scriptLoaded = true;
    return Promise.resolve();
  }

  if (loadPromise) return loadPromise;

  loadPromise = new Promise((resolve) => {
    const existingScript = document.querySelector(
      `script[src*="maps.googleapis.com/maps/api/js"]`,
    );
    if (existingScript) {
      const check = setInterval(() => {
        if (window.google?.maps) {
          scriptLoaded = true;
          clearInterval(check);
          resolve();
        }
      }, 100);
      return;
    }

    const script = document.createElement("script");
    script.src = `https://maps.googleapis.com/maps/api/js?key=${GOOGLE_API_KEY}&libraries=places&v=weekly`;
    script.async = true;
    script.onload = () => {
      const check = setInterval(() => {
        if (window.google?.maps) {
          scriptLoaded = true;
          clearInterval(check);
          resolve();
        }
      }, 100);
    };
    document.head.appendChild(script);
  });

  return loadPromise;
};
